module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer009"
    }
  }, [_c('p', {
    staticClass: "ch"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor000"
    }
  }), _vm._v("Prologue")]), _vm._v(" "), _c('p', {
    staticClass: "body-text-opening"
  }, [_c('span', {
    staticClass: "lic"
  }, [_vm._v("H")]), _vm._v("er fingers touched the pins which impaled each fragile butterfly. She felt the cold hardness, contrasting with the spread-eagled insect wings, delicate as gossamer.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The air smelled of dust, laden with a cloying sweetness. Despite her lack of sight, Beth could feel the Duke’s gaze on her. Goose pimples prickled on her neck and she shivered even though the chamber was warm from the crackling fire.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘Ren?’ she called.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘Your friend is in the other room, looking at the tiger I shot. An artistic boy, it would seem?’")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He stepped closer. ‘So, do you like the butterflies?’")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She could smell his breath, a mix of alcohol, tobacco and that odd sweetness.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘I find them sad.’")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘That is because you cannot see,’ the Duke said. ‘If you could see, you would admire their beauty. I pin them when they are still alive. The colour of their wings stays so much brighter, I find.’")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She swallowed. Her throat felt dry. Her tongue stuck to the roof of her mouth as if swollen, making words difficult to form.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘You are yourself very beautiful,’ he said. ‘An unusual beauty, a perfection that is so seldom seen in nature. Your face, your features have a perfect symmetry. That is why I like the butterflies.’")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She withdrew her hands from the display case, shifting abruptly and instinctively away. Stumbling, she felt a sharp corner strike her thigh.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘Do be careful.’ The Duke’s hand touched her arm.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She felt the pressure of his fingers and the smell of his breath. She pulled her arms back, hugging them tight to her body.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘Ren!’ she called again.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘The walls are very thick here. It is nice to know that one’s residence is well built, don’t you think?’")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She felt her breath quicken as sweat dampened her palms.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘Beth?’")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Relief bubbled up in a weird mix of euphoria and panic as she heard Ren’s familiar step.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘That stuffed tiger is fantastic,’ he said. ‘I’d love to see one alive. Did you want to feel it?’ He paused. She heard him step to her. ‘Beth, are you sick?’")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She nodded and he grasped her hand, his touch warm and familiar.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘I—would—like—to—go—home.’ She forced the words out in a staccato rhythm, each syllable punctuated with a harsh gasp.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘Do return, any time you would like,’ the Duke said.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She held tight to Ren’s hand as they exited the room and stepped down the stairs. They said nothing as they traversed the drive and then took the shortcut through the woods and back to the familiarity of Graham Hill.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("It was only as they sat in their favourite spot, leaning against the oak’s stout trunk with her hands touching the damp velvet moss, that her breathing slowed.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘Don’t let’s go there again,’ she said. ‘Ever.’")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘What happened?’")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘Nothing.’ This was true and yet she had felt more fearful than she ever had before. More fearful than the time she had fallen off the fence into the bull’s paddock. Or when she had got lost in the woods. Or when her horse had got spooked.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘He looks at you strangely.’")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘Yes, I feel it.’")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘We won’t go back,’ Ren agreed. ‘I thought he would have more animals. One tiger isn’t much.’")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘And butterflies.’")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Ren stood. He could never stay still for long, unless he was painting. ‘Let’s forget about that creepy old place. We’ll not return, not for a hundred tigers. What should we do now—fishing, or should we see if Mrs Bridges has baked?’")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Beth sniffed. ‘I think I can smell fresh scones.’")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘Your brother would say that is a scientific impossibility,’ Ren laughed.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘And yours would say we should check it out anyway.’")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He took her hand and she stood. Together they scrambled across the field towards Ren’s home. In the warm sunshine and with the promise of Mrs Bridges’s fresh baking, Beth forgot about the Duke and his butterflies.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2a261788","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Prologue.vue
// module id = 81
// module chunks = 0